<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">


          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <h3>Account Build Allocation - {{ campaignDescription.campaign_name }}</h3>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <h3>{{ campaignDescription.campaign_name }} Accounts</h3> -->
          </vs-col>
        

      

       

          


          <!-- <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button :color="acceptButtonColor" type="filled"
              @click="acceptSelected">{{ accept_text }}</vs-button>


              <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            />
          </vs-col> -->
        </vs-row>
      </div>
    </vx-card>
    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

    <vx-card class="vxtable">

              <div v-if="showSalesDeveloperSubmit">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-1/6 w-full ml-5">
                <h6>Assign To :</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchDataAdministrators"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleSalesDeveloper"
                ></SalesDeveloperAutocomplete>
                <span class="text-danger text-sm">{{
                  please_choose_sales_developer
                }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click.prevent="updateSalesDeveloperIds"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>


         <ClientDataGrid
              :key="companySDAccountComponentKey"
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="DataAdministratorClientSide"
              :columnDefs="accountColumnDefs"
              :rowData="accountRecords"
              :rowSelection="'multiple'"
            >
            </ClientDataGrid>


     
    </vx-card>


  </div>
</template>

<script>
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import _ from "lodash";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import Autocomplete from "@/components/autocomplete/Autocomplete.vue";
import vSelect from "vue-select";
import ProgressBar from 'vue-simple-progress'
 import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
export default {
  components: { Autocomplete, "v-select": vSelect , ProgressBar ,             flatPickr , ClientDataGrid,SalesDeveloperAutocomplete
},
  computed: {
    total_pages () {
      console.log("totla" , this.all_total)
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_accounts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
      selected_data_administrator_id: null,
            showSalesDeveloperSubmit: false,

            please_choose_sales_developer: null,

            companySDSearchComponentKey: 0,

         accountDataSource: [],
      accountRecords: [],
            accountColumnDefs: [],

            companySDAccountComponentKey:0,

                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      allowInvalidPreload	: false,
      enableSeconds : true
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_accounts : [],
      selected: [],
      allSelected: false,
      all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
      selected_unmatched_account : {}, 
      mandatory_fields: [],
      all_phone_codes:[],
      selected_fields: null,
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_account_name:null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      accountExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
      accountDescription: {},
      addNewAccountsPopUp: false,
      campaignDescription: [],
      export_link: null,
      enrich_account_to_master_db_link: null,
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        "ml_company",
        "ml_actual_account_name",
        [
          [
            "Head Office Address",
            "Registered Office",
            "State",
            "Town",
            "Country",
            "Postal Code",
            "Site Office"
          ]
        ]
      ],
      unmatch_accounts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      accepted_matches: [],
      combined_matches: [],
      all_total : 0
    };
  },
  mounted() {
    this.getSelectedMandatoryFields();
    this.getPhoneTypes();
    this.getCurrencyCodes();
    this.getCampaignDescription();
    this.getAllPhoneCodes()
    this.getAllSicCodes()
    this.getAllVerticals()
    this.getAllCurrencyCodes()
      this.getDataBuildAccountColumns();
      this.getAccountDataSource();
    this.export_link = "/accounts/remain_unmatched/" + this.campaignId;
    this.enrich_account_to_master_db_link =
      "/accounts/enrichAccountDataToMasterDb/" + this.campaignId;
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.accountDescription.webShow = this.accountDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.accountDescription.linkedinShow = this.accountDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          val
        );
      }
    },
    headOfficeIsRegisteredOffice(val) {
      if (val) {
        this.accountDescription.head_office_address_1 = this.accountDescription.registered_office_address_1;
        this.accountDescription.head_office_address_2 = this.accountDescription.registered_office_address_2;
        this.accountDescription.head_office_address_3 = this.accountDescription.registered_office_address_3;
        this.accountDescription.head_office_city = this.accountDescription.registered_office_city;
        this.accountDescription.head_office_county = this.accountDescription.registered_office_county;
        this.accountDescription.head_office_postcode = this.accountDescription.registered_office_postcode;
        this.accountDescription.head_office_country = this.accountDescription.registered_office_country;
      } else {
        this.accountDescription.head_office_address_1 = this.old_head_office_address_1;
        this.accountDescription.head_office_address_2 = this.old_head_office_address_2;
        this.accountDescription.head_office_address_3 = this.old_head_office_address_3;
        this.accountDescription.head_office_city = this.old_head_office_city;
        this.accountDescription.head_office_county = this.old_head_office_county;
        this.accountDescription.head_office_postcode = this.old_head_office_postcode;
        this.accountDescription.head_office_country = this.old_head_office_country;
      }
    },
    "accounts.websites"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkWebsiteExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.websiteExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This website already exists.",
                  accept: (this.websiteExists = false)
                });
                var index = this.accounts.websites.indexOf(lastItem);
                this.accounts.websites.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.websites.indexOf(lastItem);
          this.accounts.websites.splice(index, 1);
          return false;
        }
      }
    },
    "accounts.linkedins"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkLinkedinExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.linkedinExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This linkedin already exists.",
                  accept: (this.linkedinExists = false)
                });
                var index = this.accounts.linkedins.indexOf(lastItem);
                this.accounts.linkedins.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem);
          this.accounts.linkedins.splice(index, 1);
          return false;
        }
      }
    },
    currentx: function (val, oldVal) {


  


      this.unmatch_accounts = this.all_unmatched_accounts.slice((val - 1) *  this.limit, val * this.limit);
    }
  },
  methods: {
    updateSalesDeveloperIds() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.data_administrator_id = self.selected_data_administrator_id;
      data.campaign_id = self.campaignId;
      data.assigned_by = self.user_id;
      data.level = "account";

      if (self.selected_data_administrator_id == null) {
        self.please_choose_sales_developer =
          "Please select data manager to update";
      }


      console.log("data.table_ids", data.table_ids);

      self.$vs.loading();





      if (
        self.selected_data_administrator_id != null &&
        self.selected_table_ids.length != 0 &&
        self.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/updateDataAdministratorIds", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.DataAdministratorClientSide.gridApi.deselectAll();
                 self.$refs.DataAdministratorClientSide.gridApi.refreshCells({force : true});
                self.getAccountDataSource();
                self.$vs.loading.close();

              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

      
    },
   getAccountDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.campaign_id = self.campaignId;
      self.$store
        .dispatch("accountsManagement/fetchAllDataBuildAccountsForClientSide", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);



          response_data.forEach(function(ele){
            if(ele.added_to_campaign == true){
              ele.added_to_campaign = 'Yes' 
            }else{
              ele.added_to_campaign = 'No' 
            }
          })

       



          

          

          self.accountRecords = response_data;


          console.log("account Records" , self.accountRecords)

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
     getDataBuildAccountColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumnsForDataBuild",
          self.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);

              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
          
              ele.headerName = ele.name;

              if (ele.column_id != "account_status" && ele.column_id != "account_status_notes") {
                  ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

              }else{
                ele.field = ele.column_id;
              }



                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns
          let actions = {
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.accountColumnDefs.push(actions);



   let data_assigned_by = {
            field: "assigned_by",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Allocated By"
          };

          this.accountColumnDefs.push(data_assigned_by);



           let added_through = {
            field: "added_through",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added Through"
          };

          this.accountColumnDefs.push(added_through);

            let added_to_campaign_id = {
            field: "added_to_campaign_id",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added To Campaign By"
          };

          this.accountColumnDefs.push(added_to_campaign_id);


          let data_assigned_on = {
            field: "assigned_on",
            filter: "agDateColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4,
                     comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
            },
            headerName: "Allocated On"
          };

          this.accountColumnDefs.push(data_assigned_on);


          













             let added_to_campaign = {
            field: "added_to_campaign",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added to Campaign"
          };

          this.accountColumnDefs.push(added_to_campaign);

              let added_to_campaign_on = {
            field: "added_to_campaign_on",
            filter: "agDateColumnFilter",
        //     valueFormatter: (params) => {
        //   if (params.value) {
        //     return moment(params.value).format('MM/DD/YYYY'); // Or your desired format
        //   }
        //   return '';
        // },
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4,
               comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
              
            },
            headerName: "Added To Campaign On"
          };

          this.accountColumnDefs.push(added_to_campaign_on);


          let accepted = {
            field: "accepted",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Matched ID"
          };

          this.accountColumnDefs.push(accepted);

          let matched_company = {
            field: "matched_company",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Matched Company"
          };

          this.accountColumnDefs.push(matched_company);

          let data_administrator = {
            field: "data_administrator",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Data Administrator"
          };

          this.accountColumnDefs.push(data_administrator);

          let sorted = _.sortBy(this.accountColumnDefs, function(item) {
            return item.field === "data_administrator" ? 0 : 1;
          });

         

          this.accountColumnDefs = sorted;

        

        })
        .catch(err => {
          console.log(err);
        });
    },
     sendSelectionToActualPage(items) {
      let selected_table_ids = [];

      items.forEach(element => {
        selected_table_ids.push(element.table_id);
      });

      this.selected_table_ids = selected_table_ids;
      this.showSalesDeveloperSubmit = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


// this.$vs.loading();






// let matches = this.unmatch_accounts;



var matches = [...this.unmatch_accounts, ...this.all_unmatched_accounts];



if (this.allSelected) {
  matches.forEach(match => {
    this.selected.pop({ id: match.id});
  });
} else {

  

  
  // this.allSelected = false;
  matches.forEach(match => {
    this.selected.push({ id: match.id });
  });
  // this.match_ten_context.map(
  //   function(ele) {
  //     if (ele.page == this.currentx) {
  //       return (ele.ten_selected = true);
  //     }
  //   }.bind(this)
  // );
}

this.selected = this.removeDuplicates(this.selected, "id");


// this.$vs.loading.close();

},
select() {
this.allSelected = false;

// this.match_ten_context.map(
//   function(ele) {
//     if (ele.page == this.currentx) {
//       return (ele.ten_selected = false);
//     }
//   }.bind(this)
// );
},
    getSelectedMandatoryFields() {
      let self = this;
      let selected_campaign_id = self.$route.params.campaignId
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {


          self.mandatory_fields = result.filter(ele => ele.level == 'account' || ele.level == 'opportunity' );





          }

        })
        .catch(err => {
          if (err) {

            console.log(err)
            return;
          }
          console.error(err);
        });
    },
    campaignDataOptions(){




     let self  = this
   

        self.$router
              .push(
                "/accounts/optionsAfterImportAccountToCampaign/" +
                self.campaignId
              )
    


      // this.checkDuplicateExists();
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    editHeadOfficeCountry() {
      this.showHeadOfficeCountryField = false;
      this.showEditAutocomplete = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
      this.$refs.EditAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
    },
        handleSalesDeveloper() {
      this.selected_data_administrator_id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.please_choose_sales_developer = null;

      console.log("selected_data_administrator_id" , this.selected_data_administrator_id)
    },
       searchDataAdministrators(inputValue) {
      let data = {};
      data.search = inputValue;
      var self = this;
      return this.$store
        .dispatch("elomarkUsersManagement/getDataAdministrators", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showGroupCompanies() {
      const parentId = this.accountDescription.parent;
      this.$store
        .dispatch("accountsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true;
            return;
          }
          console.error(err);
        });
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllSicCodes() {
     this.$store
        .dispatch("accountsManagement/getAllSicCodes")
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllVerticals() {
     this.$store
        .dispatch("accountsManagement/getAllVerticals")
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllCurrencyCodes() {
     this.$store
        .dispatch("accountsManagement/getAllCurrencyCodes")
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
          // console.log(res.data)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.accountDescription.satellite_office = this.accountDescription.satellite_office.filter(
        item => {
          return item.counter != site.counter;
        }
      );
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    addSiteOffice() {
      this.accountDescription.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null
      });
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    removeSelectedWeb(url) {
      this.accountDescription.web = this.accountDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.accountDescription.linkedin = this.accountDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.accountDescription.sic_code = this.accountDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      console.log(selected);
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
          this.accounts.phoneType.name + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + " - " + this.accounts.phone
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phoneType = null;
    },
    addSicCodes() {
      if (
        this.accounts.sic_code &&
        this.accounts.sic_code_description &&
        !this.accounts.joinedSicAndDescription.includes(
          this.accounts.sic_code + " - " + this.accounts.sic_code_description
        )
      )
        this.accounts.joinedSicAndDescription.push(
          this.accounts.sic_code + " - " + this.accounts.sic_code_description
        );

      let mappedSicDescription = {};
      mappedSicDescription.code = this.accounts.sic_code;
      mappedSicDescription.description = this.accounts.sic_code_description;
      this.accounts.sicCodeWithDescription.push(mappedSicDescription);
      this.accounts.sic_code = null;
      this.accounts.sic_code_description = null;
    },
    addWebsite() {
      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web });
      this.accounts.web = null;
    },
    addLinkedin() {
      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin });
      this.accounts.linkedin = null;
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }
          if (moduleAccountsManagement.head_office_country_selected) {
            this.accountDescription.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name;
          }
          this.accountDescription.id = this.$route.params.accountId;

          this.accountDescription.phoneWithTypes = [];
          this.accountDescription.phone.map(phone_ele => {
            phone_ele.phone_type.map(phone_type_ele => {
              if (phone_type_ele.phone_id == phone_ele.id) {
                console.log(phone_type_ele);
                let mappedPhoneTypes = {};
                mappedPhoneTypes.phone_no = phone_ele.phone_no;
                mappedPhoneTypes.phone_type = phone_type_ele.type;
                this.accountDescription.phoneWithTypes.push(mappedPhoneTypes);
              }
            });
          });
          this.accountDescription.phoneWithTypes = _.unionBy(
            this.accountDescription.phoneWithTypes,
            this.accounts.phoneWithTypes,
            "phone_no"
          );

          this.accountDescription.sicCodeWithDescription = [];
          this.accountDescription.sic_code.map(sic_ele => {
            let mappedPhoneTypes = {};
            mappedPhoneTypes.code = sic_ele.code;
            mappedPhoneTypes.description = sic_ele.description;
            this.accountDescription.sicCodeWithDescription.push(
              mappedPhoneTypes
            );
          });
          this.accountDescription.sicCodeWithDescription = _.unionBy(
            this.accountDescription.sicCodeWithDescription,
            this.accounts.sicCodeWithDescription,
            "code"
          );

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              "The currency code field is required";
            return false;
          }
          this.addAccountAndAddToCampaign();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    submitUpdate() {


      this.$validator.validateAll().then(result => {
        if (result) {


          this.selected_unmatched_account.campaignId = this.$route.params.campaignId;
          this.selected_unmatched_account.is_new_account = "Y"

          this.$store
            .dispatch(
              "accountsManagement/addAccountAndAddToCampaign",
              this.selected_unmatched_account
            )
            .then(response => {

              this.addNewAccountsPopUp = false;


              if (response.data == "company_registration_number_exists") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Duplicate Company Registration Number`,
                  text:
                    "Company registration number already exists in the database.Please update it and submit again",
                  accept: this.addNewAccountsPopUp
                });
               }
               else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewAccountsPopUp
                });
                }
               else if (response.data == "required_correction") {
                this.$vs.dialog({
                  color: "primary",
                  title: `Required Correction`,
                  text:
                    "The fields with red title should be corrected. Please update it and submit again",
                  accept: this.addNewAccountsPopUp
                });
               }
                  else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewAccountsPopUp
                });
                }
                else if (response.data == "error") {

 this.$vs.notify({
                  color: "danger",
                  title: "Account Not Added",
                  text: "Something went wrong. Please contact administrator"
                });


}
              
              
              else {

                this.$vs.notify({
                  color: "success",
                  title: "Account Added",
                  text: "The account was added successfully"
                });


              }




              this.$router.go(0);



            })
            .catch(error => {
              console.log(error);
            });
        }

      })



    },

    acceptAlert() {
      this.addNewAccountsPopUp = true;




    },
    addAccountAndAddToCampaign() {
      this.$store
        .dispatch(
          "accountsManagement/addAccountAndAddToCampaign",
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.addNewAccountsPopUp = false;

            this.$vs.notify({
              color: "success",
              title: "Account Exists",
              text: res.data.message
            });
            this.addNewAccountsPopUp = true;

            // return false
          } else {
            this.$vs.notify({
              color: "success",
              title: "Account Added",
              text: "The account was added successfully"
            });
            this.addNewAccountsPopUp = false;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
   
    forceRerender() {
      this.componentKey += 1;
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
   
    goBack: function () {
      this.$router.go(-1);
    },
    proceedToNextStep() {

      let self = this
      this.$vs.loading.close();
      
        self.$router
              .push(
                "/accounts/enrichAccountDataToMasterDb/" +
                self.$route.params.campaignId
              )
    },
    acceptSelected() {
      
      let self = this

      self.writeSelectedAccountToMasterDB()

    


    },
    updateMasterdbFlag(){

      

        let self = this

          self.$vs.notify({
          color: "primary",
          title: "Update Master DB",
          text: "Please wait while the master db is being updated with matched excel accounts.This may take a few minutes",
        });

        self.$vs.loading()



      let data = {}
            data.campaignId = self.$route.params.campaignId;
            axios
              .post(
                self.$base_url + "/api/accounts/update_master_db_flag",
                data
              )
              .then(response => {
                if (response.data.status == "success") {
                  // console.log("Master DB Flag Updated Successfully");
                  self.$vs.loading.close();

                  self.$router
                    .push(
                      "/accounts/enrichAccountDataToMasterDb/" +
                      self.$route.params.campaignId
                    )
             


                  


                } else {
                  self.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Something went wrong. Please try again"
                  });
                }






                
                
              
              })
              .catch(error => {
                console.log(error);
              });

              self.$vs.loading.close();



    },
    writeSelectedAccountToMasterDB() {


      
      let self = this
       this.PLeasewait = "Please wait while the data is being written to the master database.This may take a few minutes"
      this.selected = this.removeDuplicates(this.selected, "id");



      let selected_data = {};
      selected_data.selected_accounts = this.selected;
      selected_data.campaignId =  this.$route.params.campaignId


    



      axios
        .post(
          this.$base_url + "/api/matched_accounts/write_selected_account_to_masterdb",
          selected_data, 
          {
            onDownloadProgress: function( progressEvent ) {

  
              let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
              
  
              if( progress == 100 ) {
                this.uploadPercentage = 100

                              }
                  
                  
                        }.bind(this),
                        onUploadProgress: function( progressEvent ) {

                  
                    
                          let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );


                if( progress == 100 ) {
                  this.uploadPercentage = 50

                }


                }.bind(this)
          }).then(response => {
            


          
          let no_of_issues = response.data.data.no_of_issues
          let no_of_added_account = response.data.data.no_of_added_account
          

          if (response.data.status == "success") {

            self.$vs.loading.close();


            if (no_of_issues == 0) {


            //  self.updateMasterdbFlag()
              
            } else {
              this.$vs.dialog({
              color: "primary",
              title: `Import Account To Campaign`,
              text: no_of_added_account + " accounts were successfully added to the campaign.  However, " + no_of_issues + " selected accounts have issues.  Please resolve these before proceeding.",
              accept: this.finished,
            });
            }


            


           
          }
      


          
        })
        .catch(error => {
          console.log(error);
        });
    },
    finished() {
      this.selected = []
      this.allSelected = false
      location.reload()

      

    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/accounts/deduplicate_csv_accounts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/accounts/optionsAfterImportAccountToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

           
    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb() {
    let self = this

    self.$vs.dialog({
        color: "primary",
        title: `Import None Core Fields`,
        text: "You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      let self = this
      let data = {};
      data.campaign_id = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/update_other_field_to_masterdb_from_csv_table",
          data
        )
        .then(response => {
          if (response.data.status == "success") {


         self.sendCompletedEmail()
            

          

            console.log("Updated other field data to master db")
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendCompletedEmail(){
       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = "Import None Core Fields has been completed."
        data.subject = "Import None Core Fields"
        axios
        .post(
          self.$base_url + "/api/accounts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Import None Core Fields",
              text: "The email has been sent"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    deduplicateOldNewCSV() {
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/deduplicate_old_new_csv_account_data",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$router.replace(
              "/accounts/deduplicateOldAndNewAccountCSVData/" + this.campaignId
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
        if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

  .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
</style>
